var map = {
	"./template.bet575": 1692,
	"./template.bet575.tsx": 1692,
	"./template.bet777": 1693,
	"./template.bet777.tsx": 1693,
	"./template.betblast": 1694,
	"./template.betblast.tsx": 1694,
	"./template.betgalaxy": 1695,
	"./template.betgalaxy.tsx": 1695,
	"./template.betprofessor": 2142,
	"./template.betprofessor.tsx": 2142,
	"./template.betroyale": 1696,
	"./template.betroyale.tsx": 1696,
	"./template.chromabet": 1697,
	"./template.chromabet.tsx": 1697,
	"./template.default": 676,
	"./template.default.tsx": 676,
	"./template.fiestabet": 2143,
	"./template.fiestabet.tsx": 2143,
	"./template.forsport": 1698,
	"./template.forsport.tsx": 1698,
	"./template.gigabet": 2144,
	"./template.gigabet.tsx": 2144,
	"./template.goldenbet888": 2145,
	"./template.goldenbet888.tsx": 2145,
	"./template.goldenrush": 2146,
	"./template.goldenrush.tsx": 2146,
	"./template.hyperbet": 2147,
	"./template.hyperbet.tsx": 2147,
	"./template.juicybet": 1699,
	"./template.juicybet.tsx": 1699,
	"./template.junglebet": 1700,
	"./template.junglebet.tsx": 1700,
	"./template.magnumbet": 1701,
	"./template.magnumbet.tsx": 1701,
	"./template.oldgill": 2148,
	"./template.oldgill.tsx": 2148,
	"./template.puntcity": 1702,
	"./template.puntcity.tsx": 1702,
	"./template.puntgenie": 1703,
	"./template.puntgenie.tsx": 1703,
	"./template.pyramidbet": 1704,
	"./template.pyramidbet.tsx": 1704,
	"./template.questbet": 2149,
	"./template.questbet.tsx": 2149,
	"./template.slambet": 2150,
	"./template.slambet.tsx": 2150,
	"./template.sterlingparker": 2151,
	"./template.sterlingparker.tsx": 2151,
	"./template.sugarcastle": 1705,
	"./template.sugarcastle.tsx": 1705,
	"./template.templebet": 1706,
	"./template.templebet.tsx": 1706,
	"./template.titanbet": 2152,
	"./template.titanbet.tsx": 2152,
	"./template.ts": 989,
	"./template.vikingbet": 1707,
	"./template.vikingbet.tsx": 1707,
	"./template.volcanobet": 1708,
	"./template.volcanobet.tsx": 1708,
	"./template.wellbet": 2153,
	"./template.wellbet.tsx": 2153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2467;